<template>
    <div>
        <transition appear name="fade" mode="out-in">
            <div class="chart-table">
                <table class="table">
                    <thead>
                        <th>Item</th>
                        <th v-for="heading in series" :key="heading">{{heading}}</th>
                    </thead>
                    <tbody>
                        <template v-for="(cValue, cName) in tableData">
                            <tr :key="'creative' + cName" class="creative">
                                <th>{{ cName }}</th>
                                <td v-for="(cValuesValue, cValuesName) in cValue.values" :key="cName + cValuesName">{{ cValuesValue }}</td>
                            </tr>
                            <template v-for="(pValue, pName) in cValue.placements">
                                <tr :key="'placement' + cName + pName" class="placement">
                                    <th>{{ pName }}</th>
                                    <td v-for="(pValuesValue, pValuesName) in pValue.values" :key="cName + pName + pValuesName">{{ pValuesValue }}</td>
                                </tr>
                                <tr v-for="(dValue, dName) in pValue.dates" :key="'date' + cName + pName + dName" class="date">
                                    <th>{{ dName }}</th>
                                    <td v-for="(dValuesValue, dValuesName) in dValue.values" :key="cName + pName + dName + dValuesName">{{ dValuesValue }}</td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </transition>
    </div>
</template>

<script>
    import Moment from 'moment';
    import store from '@/store';

    export default {
        props: {
            filters: {
                type: Object,
            },
            views: {
                type: Object,
            },
            series: {
                type: Array,
            },
        },
        data() {
            return {
                tableData: [],
            };
        },
        watch: {
            filters: {
                handler() {
                    this.makeTable();
                },
                deep: true,
            },
            views: {
                handler() {
                    this.makeTable();
                },
                deep: true,
            },
            series() {
                this.makeTable();
            },
            chartData() {
                this.makeTable();
            },
        },
        computed: {
            chartData() {
                return store.state.chartData;
            },
        },
        methods: {
            makeTable() {
                if (this.views.XValue === null) {
                    return;
                }

                // clone array. not robust. methods and Infinity will be stripped
                let filteredData = JSON.parse(JSON.stringify(this.chartData.data));

                if (Object.keys(this.filters).length) {
                    Object.keys(this.filters).forEach((filterCategory) => {
                        const filterValue = this.filters[filterCategory];

                        if (filterValue) {
                            filteredData = filteredData.filter(datum => (
                                datum.categories[filterCategory] === filterValue
                            ));
                        }
                    });
                }

                // change dates to format selected
                filteredData.forEach((datum, filteredIndex) => {
                    if (this.views.dateGroup === 'Weeks') {
                        filteredData[filteredIndex].categories.Date = Moment(datum.categories.Date, 'YYYY-MM-DD').format('W YYYY');
                    } else if (this.views.dateGroup === 'Months') {
                        filteredData[filteredIndex].categories.Date = Moment(datum.categories.Date, 'YYYY-MM-DD').format('MMMM YYYY');
                    }
                });

                const sortedData = JSON.parse(JSON.stringify(filteredData));

                const tData = {};

                sortedData.forEach((d) => {
                    if (!Object.keys(tData).includes(d.categories[this.views.XValue])) {
                        const values = {};

                        this.series.forEach((s) => {
                            values[s] = d.values[s];
                        });

                        tData[d.categories[this.views.XValue]] = {
                            values,
                        };
                    } else {
                        // [this.views.XValue] already on so add values
                        this.series.forEach((s) => {
                            tData[d.categories[this.views.XValue]].values[s] += d.values[s];
                        });
                    }
                });

                // Add CTRs
                Object.keys(tData).forEach((keyName) => {
                    const rowValues = tData[keyName].values;

                    const ctr = (rowValues.Clicks / rowValues.Impressions) * 100;
                    rowValues['CTR %'] = ctr.toLocaleString('en-GB', { maximumFractionDigits: 2 });
                });

                this.tableData = tData;
            },
        },
        mounted() {
            this.makeTable();
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/partials/variables';

    h3 {
        margin-bottom: 42px;
        font-size: 35px;
        color: $kpmg-blue;

        @media screen and (min-width: $tablet) {
            margin-bottom: 35px;
        }
    }

    .chart-table {
        margin-right: $mobile-side-gutter;
        overflow-x: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/tiles/TableChart.vue